module.exports = __webpack_public_path__ + "img/magento-version-switching_medium.f9513c9c.webp";